export const generateUniqueId = (prefix = "combo") =>
  `${prefix}-${Math.random().toString(36).substr(2, 9)}`;